<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('coop_cv')"
                        :isNewButton="true"
                        @new-button-click="createFormShow()"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('coop_cv')"
                              :isNewButton="true"
                              @new-button-click="createFormShow()"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>

            <datatable ref="datatable"
                       :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
                       :data-function="callService"
            />

            <CommonModal ref="showModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t(modalTitle) }}
                </template>
                <template v-slot:CommonModalContent>
                    <component v-if="modalComponent"
                               :is="modalComponent"
                               @createFormSuccess="actionSuccess"
                               @updateFormSuccess="actionSuccess"
                               @actionSuccess="actionSuccess"
                               :formId="formId"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>

<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header';
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';

    //Component
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';

    //Page
    import CreateForm from './CreateForm';
    import UpdateForm from './UpdateForm';
    import ShowForm from './ShowForm';

    //Service
    import CoopCvService from '@/services/CoopCvService';

    //Other
    import qs from 'qs';

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,
            Datatable,
            CommonModal,
            CreateForm,
            UpdateForm,
            ShowForm
        },
        metaInfo() {
            return {
                title: this.$t('coop_cv')
            }
        },
        data() {
            return {
                formId: null,
                modalTitle: null,
                modalComponent: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('show'),
                                    class: 'ri-eye-line',
                                    callback: (row) => {
                                        this.showFormShow(row.id);
                                    }
                                },
                                {
                                    text: this.$t('edit'),
                                    class: 'ri-pencil-line',
                                    callback: (row) => {
                                        this.updateFormShow(row.id);
                                    }
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-line',
                                    callback: (row) => {
                                        this.formDelete(row.id);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.toUpperCase('coop_cv_name'),
                            field: 'name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_cv_file'),
                            field: 'file_name',
                            formatFn: (value, row) => row.file_name || row.fileName || row.name || '-',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('label'),
                            field: 'tag_name',
                            formatFn: (val, row) => {
                                return this.getLocaleText(row, 'tag_name') || row.tag_name || row.tag_name_en || row.tag || '-';
                            },
                            hidden: false
                        }
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: false,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        created() {
            this.getRows();
        },
        methods: {
            callService(config) {
                return CoopCvService.getAll(config);
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return CoopCvService.getAll(config)
                    .then((response) => {
                        this.datatable.rows = response.data.data;
                        this.datatable.total = response.data.pagination?.total || response.data.data.length;
                    })
                    .finally(() => {
                        this.datatable.isLoading = false;
                    });
            },
            createFormShow() {
                this.formId = null;
                this.modalComponent = 'create-form';
                this.modalTitle = 'new';
                this.$refs.showModal.$refs.commonModal.show();
            },
            updateFormShow(id) {
                this.formId = id;
                this.modalComponent = 'update-form';
                this.modalTitle = 'edit';
                this.$refs.showModal.$refs.commonModal.show();
            },
            showFormShow(id) {
                this.formId = id;
                this.modalComponent = 'show-form';
                this.modalTitle = 'view';
                this.$refs.showModal.$refs.commonModal.show();
            },
            formDelete(id) {
                this.$swal.fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                }).then((result) => {
                    if (result.isConfirmed) {
                        CoopCvService.remove(id)
                            .then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.getRows();
                            });
                    }
                });
            },
            formClear() {
                this.formId = null;
                this.modalComponent = null;
                this.modalTitle = null;
            },
            actionSuccess() {
                this.$refs.showModal.$refs.commonModal.hide();
                this.getRows();
                this.formClear();
            }
        }
    }
</script>
